import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, FloatingLabel, Spinner } from 'react-bootstrap';
import Styles from '../../styles/authentication/signin.module.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { SigninHelper } from '../../helpers/auth/signin-helper';
import { Helmet } from 'react-helmet';

const SignIn: React.FC = () => {
  const {
    formErrors,
    values,
    handleSignIn,
    handleChange,
    isProcessing,
  } = SigninHelper();

  const navigate = useNavigate();

  // password show and hide
  const [showPassword, setShowPassword] = useState(false);

  // Separate states for each label's active state
  const [userActive, setUserActive] = useState(false);
  const [passActive, setPassActive] = useState(false);


  // handle the show and hide password functionality
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      <Helmet>
        <title>Sign In - Mohit's Shopping App</title>
        <meta
          name="description"
          content="Sign in to Mohit's Shopping App to access your account and enjoy a personalized shopping experience with the best deals on products you love."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="Sign In - Mohit's Shopping App" />
        <meta
          property="og:description"
          content="Access your account at Mohit's Shopping App to browse, shop, and manage your orders conveniently."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`}
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/sign-in"
        />
      </Helmet>

      {/* Main Heading of the Sign In Page */}
      <h1 className="visually-hidden">Sign In to Your Account - Mohit's Shopping App</h1>

      <section className={Styles.signinSec}>
        <Container fluid className={Styles.container}>
          <Row className={`justify-content-end ${Styles.row}`}>
            <Col className={`d-flex align-items-center justify-content-center ${Styles.col}`} md={6}>
              <div className={Styles.formWrapper}>
                <h1>Sign In</h1>
                <Form onSubmit={handleSignIn}>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Username, Email, or Phone"
                      className={`${Styles.floatingLabel} ${userActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="text"
                        placeholder="Username, Email or Phone"
                        name="email" // Using the email field for input
                        className={Styles.input}
                        autoComplete="on"  // Use camelCase for JSX
                        onFocus={() => setUserActive(true)}
                        onBlur={(e) => setUserActive(e.target.value !== '')}
                        value={values.email || ''}
                        onChange={handleChange}
                        // Set an unconventional value
                        disabled={isProcessing} // Disable when processing
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Password"
                      className={`${Styles.floatingLabel} ${passActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Password"
                        name="password"
                        className={Styles.input}
                        autoComplete="on"  // Use camelCase for JSX
                        onFocus={() => setPassActive(true)}
                        onBlur={(e) => setPassActive(e.target.value !== '')}
                        value={values.password}
                        onChange={handleChange}
                        disabled={isProcessing} // Disable when processing
                      />
                      <div
                        onClick={togglePasswordVisibility}
                        className={Styles.authToggleBtn}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </FloatingLabel>
                  </Form.Group>
                  <Button
                    type="submit"
                    className={Styles.signinBtn}
                    disabled={isProcessing}>
                    {Object.keys(formErrors).length > 0 ? (
                      'Sign In'
                    ) : isProcessing ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className={Styles.customSpinner} // Applying custom spinner styles here
                      />
                    ) : (
                      'Sign In'
                    )}
                  </Button>
                  <p className={Styles.text}>
                    Don't have an account?
                    <b className={Styles.pointer} onClick={() => navigate('/auth/sign-up')}> Sign up here</b>
                  </p>
                  <p className={Styles.text}>
                    <b className={Styles.pointer} onClick={() => navigate('/auth/verify-account')}>Forgot Password?</b>
                  </p>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SignIn;
